module.exports = __webpack_public_path__ + "img/para.f6a2366b.jpg";